import React from 'react';
import { ClearanceMatchCard, ClearanceIgnoreMatchedCard } from './';

const ClearanceMatch = ({
    submission,
    clearance,
    resolveMatched,
    ignoreMatched,
    resetClearance,
    person,
    selectedAgency
}) => (
        <div className="container">
            <div className="row">
                <div className="col-xs-12 pl pr">
                    <h1 className="mt">Checking prior submission</h1>
                    <div className="common-notification info">
                        <div className="matchMessage">
                            <p className="sub-header-firstRow">Review matches</p>
                            <p>
                                We found some similar submission at your agency, please review before
                                proceeding
                        </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row mt-x2 pl pr">
                <div className="col-xs-12 col-sm-4 col-md-3 bt pr-x2 pt pb">
                    <h4 className="text-info non-fat mb mt">Your submission</h4>
                    <div className="card card-primary">
                        <section className="pt pl-x2 pr-x2">
                            <h4>
                                {submission.type === 'oi' && "Owner's Interest"}
                                {submission.type === 'ocp' && 'Owners and Contractors Protective'}
                            </h4>
                            <address>
                                <small className="text-muted">First Name Insured</small>
                                <br />
                                {submission.primaryInsuredName} <br />
                                {submission.insuredAddress.primaryInsuredAddress} <br />
                                {submission.insuredAddress.primaryInsuredCity}{' '}
                                {submission.insuredAddress.primaryInsuredState}{' '}
                                {submission.insuredAddress.primaryInsuredZipcode}
                                <br />
                            </address>
                            <address>
                                <small className="text-muted">Project Address</small>
                                <br />
                                {submission.projectAddress.projectAddress}
                                <br />
                                {submission.projectAddress.projectCity}{' '}
                                {submission.projectAddress.projectState}{' '}
                                {submission.projectAddress.projectZipcode}
                                <br />
                            </address>
                        </section>
                    </div>
                </div>
                <div className="col-xs-12 col-sm-8 col-md-9 bt background-light-blue pl-x2 pr-x2 pt pb">
                    <h4 className="non-fat mb mt">Similar Submissions</h4>

                    {/* Slice because QA has tooooo many data and it's 99.9999% chance that there won't be so many in prod */}
                    {clearance.data.matches.slice(0, 9).map((match, i) => {
                        return (
                            <ClearanceMatchCard
                                match={match}
                                submission={submission}
                                onSubmit={resolveMatched}
                                key={i}
                                person={person}
                                selectedAgency={selectedAgency}
                            />
                        );
                    })}

                    <ClearanceIgnoreMatchedCard onSubmit={ignoreMatched} onCancel={resetClearance} />
                </div>
            </div>
        </div>
    );

export default ClearanceMatch;